import s from './TourSchedule.module.scss';
import ItenaryTitle from '../../assets/ItenaryTitle.png';
import {useState} from 'react';

const formatTimeText = (text) => {
    if (!text) return '';

    return text
        // number → letter (2of → 2 of)
        .replace(/(\d)([a-zA-Z])/g, '$1 $2')

        // letter → number (of2 → of 2)
        .replace(/([a-zA-Z])(\d)/g, '$1 $2')

        // remove extra spaces around "/"
        .replace(/\s*\/\s*/g, ' / ')

        // remove extra spaces around "-"
        .replace(/\s*-\s*/g, ' - ')

        // clean double spaces
        .replace(/\s+/g, ' ')
        .trim();
};
const TourSchedule = ({scheduleData}) => {
    const [loadedImages, setLoadedImages] = useState({});

    return (

        <div className={s.itinerarybox}>
            <div className={"row mt-5 mb-5"}>
                <div className={"col-12"}>
                    <div className={s.titleWrapper}>
                        <img
                            src={ItenaryTitle}
                            className={s.titleImage}
                            loading="lazy"
                            alt=""


                        />
                    </div>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-12"}>
                    <div className={s.itinerary}>

                        {scheduleData.map((item, index) => (
                            <div key={index} className={s.timelineItem}>

                                {/* LEFT TIME */}
                                <div className={s.time}>
                                    {formatTimeText(item.time)}
                                </div>

                                {/* DOT + LINE */}
                                <div className={s.timelineLine}>
                                    <div className={s.dot}></div>
                                </div>

                                {/* CONTENT */}
                                <div className={s.content}>
                                    <div className={"row"}>
                                        <div className={"col-12 col-md-9"}>
                                            <h5 className={s.title}>{item.event}</h5>


                                            <p className={s.description}>
                                                {item.notes}
                                            </p>

                                        </div>
                                        <div className={"col-12 col-md-3"}>
                                            {item.image && (
                                                <div className={s.imageWrapper}>

                                                    {/* Facebook-style skeleton */}
                                                    {!loadedImages[item.image] && (
                                                        <div className={s.skeleton}/>
                                                    )}

                                                    <img
                                                        src={item.image}
                                                        className={`${s.image} ${
                                                            loadedImages[item.image] ? s.show : ''
                                                        }`}
                                                        loading="lazy"
                                                        alt=""
                                                        onLoad={() =>
                                                            setLoadedImages(prev => ({
                                                                ...prev,
                                                                [item.image]: true
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>

                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default TourSchedule;
